import apiSlice from './apiSlice';

export interface DeclareResultPayload {
    market: string;
    marketType: 'NORMAL' | 'FANCY' | 'PREMIUM' | string;
    eventId: string;
    marketId: string;
    selectionId: string;
    result?: string;
}

export const betResultApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // PENDING RESULT
        declareResult: builder.mutation<any, DeclareResultPayload>({
            query: (payload) => ({
                url: '/bet-result/declare',
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['PendingMarkets'],
        }),

        // ROLLBACK RESULT
        rollbackResult: builder.mutation<any, DeclareResultPayload>({
            query: (payload) => ({
                url: '/bet-result/manual/rollback',
                method: 'POST',
                body: payload,
            }),
            // invalidatesTags: ['RollbackMarkets'],
        }),
    }),
});

export const { useDeclareResultMutation, useRollbackResultMutation } = betResultApi;
